// Нова ниша › steps 1–3: pick a vertical, pick a city, tick the areas.

import type { VerticalRow } from '../verticals/useVerticals.js';
import type { CityAreaRow, CityRow } from '../cities/useCities.js';

export function StepVertical({
  verticals,
  value,
  onPick,
}: {
  verticals: VerticalRow[];
  value: string | null;
  onPick: (key: string) => void;
}) {
  const presets = verticals.filter((v) => !v.active);
  const active = verticals.filter((v) => v.active);

  const card = (v: VerticalRow, tag: string) => (
    <button
      key={v.key}
      type="button"
      className={`adm__pick ${value === v.key ? 'adm__pick--on' : ''}`}
      onClick={() => onPick(v.key)}
    >
      <span className="adm__pick-title">{v.name_bg}</span>
      <span className="adm__pick-tag">{tag}</span>
      <span className="adm__pick-sub">
        {v.synonyms_bg.length} синонима · {v.services_bg.length} услуги ·{' '}
        {v.search_languages.join('/')}
      </span>
    </button>
  );

  return (
    <div className="adm__wizard-step">
      <h4 className="adm__h">1. Коя ниша?</h4>
      <p className="adm__note">
        Шаблоните са готови речници, които стоят изключени. Активна ниша се избира, за да се разшири
        към нов град.
      </p>
      <div className="adm__picks">{presets.map((v) => card(v, 'шаблон'))}</div>
      {active.length > 0 ? (
        <>
          <p className="adm__sub">Вече активни</p>
          <div className="adm__picks">{active.map((v) => card(v, 'активна'))}</div>
        </>
      ) : null}
      {verticals.length === 0 ? (
        <p className="adm__msg">Няма ниши. Създайте една от „Ниши“.</p>
      ) : null}
    </div>
  );
}

export function StepCity({
  cities,
  value,
  onPick,
}: {
  cities: CityRow[];
  value: string | null;
  onPick: (key: string) => void;
}) {
  return (
    <div className="adm__wizard-step">
      <h4 className="adm__h">2. Кой град?</h4>
      <div className="adm__picks">
        {cities.map((city) => (
          <button
            key={city.key}
            type="button"
            className={`adm__pick ${value === city.key ? 'adm__pick--on' : ''}`}
            onClick={() => onPick(city.key)}
          >
            <span className="adm__pick-title">{city.name_bg}</span>
            <span className="adm__pick-tag">{city.active ? 'активен' : 'неактивен'}</span>
            <span className="adm__pick-sub">
              {city.name_lat ?? city.name_en} · радиус {city.radius_m ?? '—'} м
            </span>
          </button>
        ))}
      </div>
      {cities.length === 0 ? (
        <p className="adm__msg">Няма градове. Добавете един от „Градове и райони“.</p>
      ) : null}
    </div>
  );
}

export function StepAreas({
  areas,
  ticked,
  onToggle,
  onSetAll,
}: {
  areas: CityAreaRow[];
  ticked: ReadonlySet<number>;
  onToggle: (id: number) => void;
  onSetAll: (on: boolean) => void;
}) {
  return (
    <div className="adm__wizard-step">
      <h4 className="adm__h">3. Кои райони?</h4>
      <p className="adm__note">
        Всеки район носи заявки „ядро × район“; районите с тежест 2 — и „услуги × район“. Отметнати
        са тези, които са „в заявките“ по подразбиране.
      </p>
      <div className="adm__actions">
        <button type="button" className="adm__json-btn" onClick={() => onSetAll(true)}>
          Всички
        </button>
        <button type="button" className="adm__json-btn" onClick={() => onSetAll(false)}>
          Никой
        </button>
        <span className="adm__sub">
          {ticked.size} от {areas.length}
        </span>
      </div>
      <div className="adm__checks adm__checks--grid">
        {areas.map((area) => (
          <label key={area.id} className="adm__check">
            <input
              type="checkbox"
              className="adm__toggle-check"
              checked={ticked.has(area.id)}
              onChange={() => onToggle(area.id)}
            />
            <span>
              {area.name}
              {area.search_weight >= 2 ? <span className="adm__pick-tag"> голям</span> : null}
            </span>
          </label>
        ))}
      </div>
      {areas.length === 0 ? (
        <p className="adm__msg">
          Градът няма райони — матрицата ще съдържа само заявки за целия град.
        </p>
      ) : null}
    </div>
  );
}
